import { swSettings } from "app/common/services/swSettings";

import { createSolutionUrlsService } from "./factory";
import type { ISolutionUrlsProvider } from "./types";

let solutionUrlsService: ISolutionUrlsProvider | undefined;

const getSolutionUrlsService = (): ISolutionUrlsProvider => {
    solutionUrlsService ??= createSolutionUrlsService({ settingsProvider: swSettings });
    return solutionUrlsService;
};

const solutionUrlsServiceFacade: ISolutionUrlsProvider = {
    getAppAnalysisUrl: (...args) => getSolutionUrlsService().getAppAnalysisUrl(...args),
    getAccountUrl: (...args) => getSolutionUrlsService().getAccountUrl(...args),
    getAccountManagementUrl: (...args) => getSolutionUrlsService().getAccountManagementUrl(...args),
    getAccountDataCreditsUrl: (...args) => getSolutionUrlsService().getAccountDataCreditsUrl(...args),
    getStandardApiUrl: (...args) => getSolutionUrlsService().getStandardApiUrl(...args),
    getTrialUpgradeUrl: (...args) => getSolutionUrlsService().getTrialUpgradeUrl(...args),
    getSiUpgradePurchaseUrl: (...args) => getSolutionUrlsService().getSiUpgradePurchaseUrl(...args),
};

export default solutionUrlsServiceFacade;
